import { createFileRoute, useParams } from '@tanstack/react-router'

import { MultiRequestDrawer } from '../../../../components/request-drawer/multi-request-drawer/components/MultiRequestDrawer'

export const Route = createFileRoute('/app/requests/$id/mobile')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = useParams({ from: '/app/requests/$id/mobile' })
  return <MultiRequestDrawer requestId={id} />
}
